import styled from 'styled-components';
import theme from 'src/theme';

export interface IButtonProps {
    isSelected?: boolean;
    onClick?: (eventTypeId: number) => void;
}

export const PageContentWrapper = styled.div`
    height: 100%;
    padding: 0px 0px 0px 5px;
    display: flex;
    justify-content: space-between;
`;

export const LeftContentWrapper = styled.div`
    flex: 0 0 calc(45% - 5px);
    height: calc(100% - 5px);
    overflow: hidden;
    box-shadow: #ccc 0 2px 6px 2px;
`;

export const EventWrapper = styled.div`
    flex: 0 0 calc(30% - 5px);
    max-width: calc(30% - 5px);
    overflow: hidden;
    position: relative;
    height: calc(100% - 5px);
    box-shadow: #ccc 0 2px 6px 2px;

    &.is-shrunk {
        flex: 0 0 0;
        max-width: 0;
        overflow: hidden;
    }
`;

export const RightContentWrapper = styled.div`
    flex: 0 0 calc(25% - 5px);
    max-width: calc(25% - 5px);
    height: calc(100% - 5px);
    overflow: hidden;
    box-shadow: #ccc 0 2px 6px 2px;

    &.is-expanded {
        flex: 0 0 calc(55% - 5px);
        max-width: calc(55% - 5px);
    }
`;

export const LeftTopWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 60px;
    background: ${theme.legacyColors.headingPanelBgColor};
    padding: 15px 10px;
    color: ${theme.legacyColors.headingColor};
    border-bottom: 2px solid ${theme.legacyColors.headingColor};
    position: relative;
`;

export const RightWrapper = styled.div`
    flex: 0 0 90%;
    max-width: 90%;
`;

export const HeadingWrapper = styled.div`
    background: ${theme.legacyColors.headingPanelBgColor};
    height: 60px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    h3 {
        font-size: 0.9rem;
        font-weight: 500;
        padding: 0;
        margin: 0 10px;
        color: ${theme.legacyColors.headingColor};
        p {
            margin: 0;
            font-size: 0.7rem;
            color: ${theme.legacyColors.headingColor};
        }
    }
`;

export const LeftHeadingWrapper = styled.div`
    flex: 0 0 40%;
    max-width: 40%;
    display: flex;
    align-items: center;
`;

export const RightHeadingWrapper = styled.div`
    display: flex;
    flex: 0 0 60%;
    max-width: 60%;
    justify-content: flex-end;
    align-items: center;
    color: ${theme.legacyColors.headingColor};
`;

export const HeadingOuterWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    border-bottom: 2px solid ${theme.legacyColors.headingColor};
`;

export const TitleOuterWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h3 {
        color: ${theme.legacyColors.headingColor};
        font-size: 0.9rem;
        @media only screen and (max-width: 1600px) {
            font-size: 0.75rem;
        }
        font-weight: 500;
        padding: 0;
        margin: 0 10px;
        p {
            margin: 0;
            font-size: 0.7rem;
            @media only screen and (max-width: 1600px) {
                font-size: 0.5rem;
            }
        }
    }
`;

export const DeleteEventsWrapper = styled.div`
    display: flex;
    height: 40px;
    margin-top: 10px;
    h3 {
        font-size: 0.9rem;
        font-weight: 500;
        padding: 0;
        margin: 0 10px;
        p {
            margin: 0;
            font-size: 0.7rem;
        }
    }
`;

export const DeleteTextWrapper = styled.div`
    display: flex;
`;

export const DeleteButtonsWrapper = styled.div`
    display: flex;
`;

export const LeftBottomWrapper = styled.div`
    flex: 0 0 60%;
    border-right: 1px solid #ddd;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
`;

export const RightBottomWrapper = styled.div`
    height: 100%;
`;

export const EventListFooter = styled.div`
    display: flex;
    height: 50px;
`;

export const LastUpdated = styled.div`
    font-size: 0.7rem;
    font-weight: 400;
    margin: 0 0 0 10px;
    color: ${theme.legacyColors.headingColor};
`;

export const ReportingContextWrapper = styled.nav`
    display: flex;
    align-items: center;
    color: ${theme.legacyColors.headingColor};
    h3 {
        font-size: 0.9rem;
        font-weight: 500;
        display: inline-block;
        padding-left: 10px;
        color: ${theme.legacyColors.headingColor};
    }

    h4 {
        font-size: 0.8rem;
        font-weight: 400;
        display: inline-block;
        margin: 0 0 0 10px;
        color: ${theme.legacyColors.headingColor};
        max-width: 600px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        span.separator {
            margin: 0 5px;
        }
    }
`;

export const DetailsCheckboxWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 3px 10px;
    margin: 0 6px 0 0;
`;

export const DetailsText = styled.div`
    font-size: 0.7rem;
    font-weight: 400;
`;
